// extracted by mini-css-extract-plugin
export var icon = "_wk-0";